import { useCallback, useEffect, useState } from 'react';
import { MedicalServiceCategory } from '../../../models/Entities/MedicalServices/MedicalServiceHierarchy';
import * as CategoriesService from '../../../services/MedicalServiceCategories.Services';

export interface MedicalServiceCategoriesState {
  categories: MedicalServiceCategory[];
  loading: boolean;
  /** No se pudieron traer (API anterior sin la ruta, o error de red). */
  unavailable: boolean;
  /** Vuelve a pedirlas (p. ej. después de administrar categorías). */
  reload: () => void;
}

/**
 * Trae todas las categorías de servicios mientras el drawer esté abierto. Si el pedido falla,
 * el formulario sigue funcionando sin selector de categoría.
 */
export const useMedicalServiceCategories = (token: string | undefined, enabled: boolean): MedicalServiceCategoriesState => {
  const [categories, setCategories] = useState<MedicalServiceCategory[]>([]);
  const [loading, setLoading] = useState(false);
  const [unavailable, setUnavailable] = useState(false);
  const [version, setVersion] = useState(0);

  const reload = useCallback(() => setVersion((current) => current + 1), []);

  useEffect(() => {
    if (!enabled || !token) return;
    let cancelled = false;
    setLoading(true);
    setUnavailable(false);
    Promise.resolve()
      .then(() => CategoriesService.GetAllMedicalServiceCategories(token))
      .then((list) => { if (!cancelled) { setCategories(list ?? []); setUnavailable(false); } })
      .catch(() => { if (!cancelled) { setCategories([]); setUnavailable(true); } })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [enabled, token, version]);

  return { categories, loading, unavailable, reload };
};

export default useMedicalServiceCategories;
